<template>
  <el-dialog
    title=""
    width="80%"
    top="4%"
    :visible="true"
    :before-close="
      () => {
        _pageQuery.pageNo = 1;
        $emit('refreshList');
        $emit('close');
      }
    "
  >
    <base-form
      ref="baseForm"
      :tableSearch="tableSearchItems"
      @change="SET_TABLE_SEARCH_QUERY"
      @search="
        getList({ isSelected: 0, id, projectId: $route.query.projectId })
      "
    ></base-form>

    <base-table
      height="450"
      rowKey="id"
      @select-all="selectCurrentPageAll"
      :tableColumn="tableColumn"
      v-loading="tableLoading"
      :data="tableData"
    />
    <base-pagination
      :value="_pageQuery"
      :total="pageTotal"
      :page-size="_pageQuery.pageSize"
      @input="pageChange"
      :disabled="tableLoading"
    />
  </el-dialog>
</template>

<script>
import baseForm from '../components/Base/baseForm';
import baseTable from '../components/Base/baseTable';
import basePagination from '../components/Base/basePagination';
import request from '@/tools/request';
import { mapState, mapMutations, mapActions } from 'vuex';
import initProject from '../mixins/sync-project';
import openDetail from '../services/open-detail';
import { auditOssStatus } from '../api';

const ENUMS = {
  auditStatus: [
    '未提交审核',
    '审核中',
    '审核通过',
    '审核未通过',
    '审核中（重新提交）'
  ],
  auditOssStatus: ['未提交审核', '审核中', '审核通过', '审核未通过'],
  auditGongyeStatus: ['未提交审核', '审核中', '审核通过', '审核未通过']
};

export default {
  name: 'task-count', //任务数
  mixins: [initProject],
  props: ['id', 'numberOfAuditTasks', 'auditRecordState'],
  components: {
    baseForm,
    baseTable,
    basePagination
  },
  data() {
    return {
      tableSearchItems: [
        {
          type: 'daterange',
          fieldKeys: ['finishDtStart', 'finishDtEnd'],
          'start-placeholder': '提交时间起',
          'end-placeholder': '提交时间止'
        },
        {
          type: 'input',
          fieldKey: 'userName',
          placeholder: '项目参与人'
        },
        {
          type: 'input',
          placeholder: '手机号',
          fieldKey: 'phone'
        },
        {
          type: 'input',
          placeholder: '任务编码',
          fieldKey: 'taskCode'
        },
        {
          type: 'select',
          label: '', //服务商状态
          placeholder: '服务商状态',
          fieldKey: 'auditStatus',
          options: [
            { label: '未提交审核', value: 0 },
            { label: '审核中', value: 1 },
            { label: '审核通过', value: 2 },
            { label: '审核未通过', value: 3 }
            // { label: '审核中', value: 5 }
          ]
        },
        {
          type: 'select',
          placeholder: '平台状态',
          fieldKey: 'auditOssStatus',
          options: [
            { label: '未提交审核', value: 0 },
            { label: '审核中', value: 1 },
            { label: '审核通过', value: 2 },
            { label: '审核未通过', value: 3 }
          ]
        },
        {
          type: 'select',
          placeholder: '工业状态',
          fieldKey: 'auditGongyeStatus',
          options: [
            { label: '未提交审核', value: 0 },
            { label: '审核中', value: 1 },
            { label: '审核通过', value: 2 },
            { label: '审核未通过', value: 3 }
          ]
        },
        {
          type: 'select',
          placeholder: '是否过期',
          fieldKey: 'isOverdue',
          options: [
            { label: '未过期', value: 0 },
            { label: '已过期', value: 1 }
          ]
        }
      ],
      tableColumn: [
        { type: 'index' }, //
        { label: '项目参与人', prop: 'userName' }, //
        { label: '手机号', prop: 'phone' }, //
        { label: '任务编码', prop: 'taskCode' }, //
        { label: '提交时间', prop: 'finishDt' }, //
        {
          label: '服务商状态',
          prop: 'auditStatus',
          formatter: ({ val }) => {
            return ENUMS['auditStatus'][val];
          }
        }, // 0 未提交审核 1审核中 2审核通过 3审核未通过 5 审核中（重新提交）
        {
          label: '平台状态',
          prop: 'auditOssStatus',
          formatter: ({ val }) => {
            return ENUMS['auditOssStatus'][val];
          }
        }, // 0 未提交审核 1审核中 2审核通过 3审核未通过
        {
          label: '工业状态',
          prop: 'auditGongyeStatus',
          formatter: ({ val }) => {
            return ENUMS['auditGongyeStatus'][val];
          }
        }, // 0 未提交审核 1审核中 2审核通过 3审核未通过
        {
          label: '是否过期',
          prop: 'isOverdue',
          formatter: ({ val }) => {
            return ['未过期', '已过期'][val];
          }
        }, //  0 未过期(默认)  1 已过期
        {
          label: '操作',
          width: '120px',
          render: (h, { row }) => {
            return (
              <div>
                <el-button
                  type="text"
                  size="mini"
                  onClick={openDetail.bind(this, {
                    auditApi: auditOssStatus,
                    row,
                    auditRecordState: this.auditRecordState,
                    whetherThisRecordCanBeManipulated:
                      row.whetherThisRecordCanBeManipulated,
                    tableSearchQuery: this.tableSearchQuery,
                    projectDetail: this.projectDetail,
                    needNext: false, // 详情审核后直接关闭
                    getList: this._getList
                  })}
                >
                  查看
                </el-button>
              </div>
            );
          }
        }
      ]
    };
  },
  computed: {
    ...mapState('dataAnalysis', ['projectDetail']),
    ...mapState('dataAnalysis/auditRecord', [
      'tableData',
      'tableLoading',
      'pageTotal',
      'isAll',
      'tableSearchQuery'
    ]),
    _pageQuery: {
      get: function() {
        return this.$store.state['dataAnalysis']['auditRecord']['pageQuery'];
      },
      set: function(v) {
        this.$store.commit('dataAnalysis/auditRecord', 'SET_PAGE_QUERY', v);
      }
    }
  },
  methods: {
    ...mapMutations('dataAnalysis/auditRecord', ['SET_TABLE_SEARCH_QUERY']),
    ...mapActions('dataAnalysis/auditRecord', ['getList']),
    pageChange(query) {
      this.$store.commit(
        'dataAnalysis/auditRecord/SET_PAGE_QUERY',
        Object.assign(query, { id: this.id })
      );
      this.getList();
    },
    _getList(query) {
      this.getList({
        isSelected: 0,
        id: this.id,
        projectId: +this.$route.query.projectId,
        ...query
      });
    },
    async selectCurrentPageAll(isSelected) {
      const taskIds = this.tableData
        .filter(i => i.whetherThisRecordCanBeManipulated === 1)
        .map(i => i.taskId);
      const params = {
        isDelete: isSelected ? '0' : '1',
        taskIds: taskIds,
        projectId: +this.$route.query.projectId
      };
      await request.post(
        '/rest/cso/saas/taskRecord/auditOssStatusSonList/edit',
        params,
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          notUseQs: true
        }
        // { notUseQs: true }
      );
      this.getList({
        isSelected: 1,
        id: this.id,
        projectId: +this.$route.query.projectId
      });
    }
  },
  created() {
    this.getList({
      isSelected: 0,
      id: this.id,
      projectId: this.$route.query.projectId
    });
  }
};
</script>

<style scoped></style>
